import React from "react";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { IconButton, Theme } from "@mui/material";
import { formatISO } from "date-fns";
import { useLocation } from "react-router-dom";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import BoxLink from "./BoxLink";

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      width: "100%",
      overflowX: "auto",
      justifyContent: "flex-start",
      paddingBottom: theme.spacing(1),
      "&::-webkit-scrollbar": { display: "none" },
      scrollbarWidth: "none",
    },
  },
  rightArrow: {
    position: "absolute",
    right: "-24px",
    [theme.breakpoints.down("md")]: {
      position: "static",
      flexShrink: 0,
      marginLeft: theme.spacing(1),
    },
  },
  leftArrow: {
    position: "absolute",
    left: "-20px",
    [theme.breakpoints.down("md")]: {
      position: "static",
      flexShrink: 0,
      marginRight: theme.spacing(1),
    },
  },
}));

const ArrowBackwardIosIcon = withStyles(ArrowForwardIosIcon, {
  root: {
    transform: "rotate(180deg)",
  },
});

const StyledIconButton = withStyles(IconButton, {
  root: {
    border: "1px solid #EDF0F5",
    zIndex: 9,
    backgroundColor: colors.white,
    "&:hover": {
      background: "#EDF0F5",
    },
  },
});

interface BoxesProps {
  dates: Date[];
  onNextWeek: () => void;
  onPrevWeek: () => void;
}

const Boxes: React.FC<BoxesProps> = ({ dates, onNextWeek, onPrevWeek }) => {
  const { classes } = useStyles();
  const location = useLocation();

  const handleTo = (location: any, date: Date) => {
    const routeParts = location.pathname.split("/");
    const [_, clients, clientId, diary, _date, exercise] = routeParts;
    const newDate = formatISO(date, { representation: "date" });
    return [_, clients, clientId, diary, newDate, exercise].join("/");
  };
  return (
    <>
      <main className={classes.root}>
        <StyledIconButton className={classes.leftArrow} onClick={onPrevWeek}>
          <ArrowBackwardIosIcon fontSize="small" />
        </StyledIconButton>
        {dates?.map((date, index) => {
          return (
            <BoxLink to={handleTo(location, date)} key={index} date={date} />
          );
        })}
        <StyledIconButton onClick={onNextWeek} className={classes.rightArrow}>
          <ArrowForwardIosIcon fontSize="small" />
        </StyledIconButton>
      </main>
    </>
  );
};

export default Boxes;
